module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staticReport"
  }, [_c('upload-excel', {
    style: ({
      marginRight: _vm.$i18n.locale === 'ae' ? '5px' : '0'
    }),
    on: {
      "on-selected-file": _vm.getExcelData
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "staticFloat",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.toExportExcel
    }
  }, [_vm._v(_vm._s(_vm.$t('other.exportExcel')))]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "staticFloat",
    attrs: {
      "type": "daterange",
      "range-separator": _vm.$t('button.to'),
      "start-placeholder": _vm.$t('button.startDate'),
      "end-placeholder": _vm.$t('button.endDate'),
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('other.selectExportType')
    },
    model: {
      value: (_vm.tableType),
      callback: function($$v) {
        _vm.tableType = $$v
      },
      expression: "tableType"
    }
  }, _vm._l((_vm.tableOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, _vm._l((_vm.tableHeader), function(item) {
    return _c('el-table-column', {
      key: item,
      attrs: {
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50522ca7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/staticReport.vue
// module id = 1166
// module chunks = 1